<div class="dialog dialog--how how">
  @if (gameTypeLogoSrc; as src) {
    <div class="how__game-type">
      <img [src]="src" alt="" class="how__game-type-img" />
    </div>
  }
  <h3 class="how__title">How it works?</h3>
  <div class="how__content">
    <ng-container *ngComponentOutlet="contentComponent()" />
  </div>
  <footer class="dialog__footer">
    <button type="button" mat-flat-button color="primary" class="btn btn--submit" (click)="closeDialog()">Got It</button>
  </footer>
</div>
